module.exports = __webpack_public_path__ + "img/noti-checked.0e8f2113.svg";